import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-calendar-check-02',
  imports: [],
  templateUrl: './calendar-check-02.html',
  styleUrl: './calendar-check-02.scss',
})
export class CalendarCheck02 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
